import { render, staticRenderFns } from "./UsableFunctionSwitch.vue?vue&type=template&id=80c25f10&scoped=true&lang=pug"
import script from "./UsableFunctionSwitch.vue?vue&type=script&lang=ts"
export * from "./UsableFunctionSwitch.vue?vue&type=script&lang=ts"
import style0 from "./UsableFunctionSwitch.vue?vue&type=style&index=0&id=80c25f10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c25f10",
  null
  
)

export default component.exports